<template>
  <div>
    <br-component component="main" />
  </div>
</template>
<script lang="ts" setup></script>
